import { render, staticRenderFns } from "./CustomerAutofill.vue?vue&type=template&id=52bc110a&scoped=true"
import script from "./CustomerAutofill.vue?vue&type=script&lang=js"
export * from "./CustomerAutofill.vue?vue&type=script&lang=js"
import style0 from "./CustomerAutofill.vue?vue&type=style&index=0&id=52bc110a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc110a",
  null
  
)

export default component.exports